module.exports = __webpack_public_path__ + "static/media/logo_drakkar.07f0b8ed.png";